import React, { useState } from "react";

const FaqsAccordion = ({FaqItemsList}) => {
  
    const [activeFaq, setActiveFaq] = useState(0);

    const toggleFaq = (id) => {
      if (activeFaq === id) {
        setActiveFaq(null);
      } else {
        setActiveFaq(id);
      }
    };
  return (
    <>
      <div
        className="accordion text-start faqs"
        id="faqAccordion"
      >
        {FaqItemsList.map((item, index) => (
          <div
            className={`accordion-item bg-white mb-31 pt-15 pt-sm-14 pt-md-20 pt-lg-28 pb-15 pb-sm-14 pb-md-20 pb-lg-28 px-15 px-sm-20 px-md-26 px-lg-37 ${
              activeFaq === item.id ? "active-shadow" : ""
            }`}
            key={index}
          >
            <h2 className="accordion-header" id={`heading${item.id}`}>
              <button
                className={`accordion-button fw-bold bg-white p-0 ${
                  activeFaq === item.id ? "" : "collapsed"
                }`}
                type="button"
                onClick={() => toggleFaq(item.id)}
              >
                {item.question}
              </button>
            </h2>
            <div
              id={`collapse${item.id}`}
              className={`accordion-collapse collapse ${
                activeFaq === item.id ? "show" : ""
              }`}
            >
              <div className="accordion-body p-0 fw-normal">
                {item.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default FaqsAccordion;
